<template>
  <div class="page-wrap api-content">
    <ul>
      <li v-for="(item, index) in documentList" :key="index">
        <a :href="item.name">
          {{ item.name }}
        </a>
        <a
          :href="item.path"
          :download="item.name"
          target="_blank"
          class="btn-a"
        >
          点击下载
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "API",
  components: {},
  data() {
    return {
      documentList: [
        {
          name: "小猪开放平台民宿类商品通用输入文档.pdf",
          path: "/小猪开放平台民宿类商品通用输入文档.pdf"
        },
        {
          name: "小猪开放平台民宿类PMS服务文档V2.pdf",
          path: "/小猪开放平台民宿类PMS服务文档V2.pdf"
        },
        {
          name: "小猪开放平台PMS酒店接入文档.pdf",
          path: "/小猪开放平台PMS酒店接入文档.pdf"
        },
        {
          name: "小猪开放平台酒店类商品通用输出文档.pdf",
          path: "/小猪开放平台酒店类商品通用输出文档.pdf"
        },
        {
          name: "小猪开放平台酒店类商品通用输入文档.pdf",
          path: "/小猪开放平台酒店类商品通用输入文档.pdf"
        }
      ]
    };
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.api-content {
  ul {
    padding: 100px;
    display: flex;
    justify-content: space-between;
    li {
      width: 200px;
      .btn-a {
        display: block;
        color: #070784;
        font-size: 14px;
      }
    }
  }
}
</style>
